import { useQuery } from '@tanstack/react-query';
import { get } from '../../nucleo/api';

/** CRM lote 5: fontes, campanhas e os nomes dos 5 níveis da qualificação (Configurações do CRM, `/pipeline/crm/listas`). */
export interface Listas {
  fontes: { nome: string; descricao: string }[];
  campanhas: { nome: string; descricao: string }[];
  fontes_livres: boolean;
  campanhas_livres: boolean;
  niveis: string[];
  /** Ajustes do CRM (27/10, F12): o parabéns depois de marcar a venda. */
  celebrar_venda?: boolean;
}

export const useListas = () => useQuery({ queryKey: ['pipeline', 'crm', 'listas'], queryFn: () => get<Listas>('/pipeline/crm/listas'), staleTime: 60_000 });

/** Id da pergunta do questionário a partir do texto (minúsculas, sem acento, com hífen; único dentro do questionário). */
export const idDaPergunta = (texto: string, usados: Set<string>): string => {
  const base = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 30).replace(/^-+|-+$/g, '') || 'pergunta';
  let idp = base;
  for (let n = 2; usados.has(idp); n++) idp = `${base}-${n}`;
  usados.add(idp);
  return idp;
};
